<div class="modal-body">
  <sd-callback-form [callBackType]="'SMARTHOMEREQUEST'"></sd-callback-form>
</div>
